// Third-party payment method brand name.
const IDEAL_BRAND_NAME = 'iDEAL';
const WERO_BRAND_NAME = 'Wero';
export const IDEAL_WERO_BRAND_NAME = `${IDEAL_BRAND_NAME} | ${WERO_BRAND_NAME}`;
